var exports = {
  "kL": "InlineEdit.module__container___QkpHND",
  "A": "InlineEdit.module__inlineTextBase___QkpHND",
  "Np": "InlineEdit.module__idleButton___QkpHND",
  "iE": "InlineEdit.module__wrapper___QkpHND",
  "qf": "InlineEdit.module__placeholder___QkpHND",
  "LL": "InlineEdit.module__editable___QkpHND",
  "NY": "InlineEdit.module__affix___QkpHND",
  "Qq": "InlineEdit.module__text___QkpHND",
  "z3": "InlineEdit.module__error___QkpHND",
};

module.exports = exports;
